import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class WhInvenDetailListItem extends SearchModelBase {
    postDate: string | null = null;
    centerNo: string = '';
    refNo: string = '';
    trucker: string = '';
    fromTo: string = '';
    itemNo: string = '';
    location: string = '';
    poNo: string = '';
    qty: number|null = null;
    box: number|null = null;
    itemDesc: string = '';
    lbs: number|null = null;
    cft: number|null = null;
    status: string = '';
    remark: string = '';
    id: number = 0;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    fromQty: number|null = null;
    toQty: number|null = null;
    fromBox: number|null = null;
    toBox: number|null = null;
    fromLbs: number|null = null;
    toLbs: number|null = null;
    fromCft: number|null = null;
    toCft: number|null = null;
    boxUnit: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        // XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'stat', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, hiddenInColumnSetup: true}),
        // XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date}),
        // XCol.Create({ col: 2, text: 'Customer', width: 120, dataIndex: 'centerNo'}),
        // XCol.Create({ col: 3, text: 'Reference No', width: 100, dataIndex: 'refNo'}),
        // XCol.Create({ col: 4, text: 'Trucker', width: 120, dataIndex: 'trucker'}),
        // XCol.Create({ col: 5, text: 'Ship From/To', width: 120, dataIndex: 'fromTo'}),
        // XCol.Create({ col: 6, text: 'Prod Code/SKU', width: 120, dataIndex: 'itemNo'}),
        // XCol.Create({ col: 7, text: 'Location', width: 80, dataIndex: 'location'}),
        // XCol.Create({ col: 8, text: 'P.O No', width: 80, dataIndex: 'poNo'}),
        // XCol.Create({ col: 9, text: 'Pack Qty', width: 80, dataIndex: 'qty', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0'}),
        // XCol.Create({ col: 10, text: 'Qty', width: 50, dataIndex: 'box', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00'}),
        // XCol.Create({ col: 11, text: 'Unit', width: 60, dataIndex: 'boxUnit'}),
        // XCol.Create({ col: 12, text: 'Item Description', width: 150, dataIndex: 'itemDesc'}),
        // XCol.Create({ col: 13, text: 'LBS', width: 80, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0'}),
        // XCol.Create({ col: 14, text: 'CFT', width: 80, dataIndex: 'cft', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00'}),
        // XCol.Create({ col: 15, text: 'Status', width: 80, dataIndex: 'status'}),
        // XCol.Create({ col: 16, text: 'Remark', width: 200, dataIndex: 'remark'})
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'stat', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date}),
        XCol.Create({ col: 2, text: 'Customer (WH)', width: 120, dataIndex: 'centerNo', defaultColumnFocus : true}),
        XCol.Create({ col: 3, text: 'Reference #', width: 100, dataIndex: 'refNo'}),
        XCol.Create({ col: 4, text: 'Trucker', width: 120, dataIndex: 'trucker'}),
        XCol.Create({ col: 5, text: 'Ship From/To', width: 120, dataIndex: 'fromTo'}),
        XCol.Create({ col: 6, text: 'Prod Code/SKU', width: 120, dataIndex: 'itemNo'}),
        XCol.Create({ col: 7, text: 'Location', width: 80, dataIndex: 'location'}),
        XCol.Create({ col: 8, text: 'P.O #', width: 80, dataIndex: 'poNo'}),
        XCol.Create({ col: 9, text: 'Qty', width: 80, dataIndex: 'qty', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 10, text: 'Box', width: 80, dataIndex: 'box', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 11, text: 'Unit', width: 60, dataIndex: 'boxUnit'}),
        XCol.Create({ col: 12, text: 'Item Description', width: 150, dataIndex: 'itemDesc'}),
        XCol.Create({ col: 13, text: 'LBS', width: 80, dataIndex: 'lbs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 14, text: 'CFT', width: 80, dataIndex: 'cft', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 15, text: 'Status', width: 80, dataIndex: 'status'}),
        XCol.Create({ col: 16, text: 'Remark', width: 200, dataIndex: 'remark'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: WhInvenDetailListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: WhInvenDetailListItem[]) {
        return data.map((d: WhInvenDetailListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        postDate: {from: 'fromPostDate', to: 'toPostDate'},
        qty: {from: 'fromQty', to: 'toQty'},
        box: {from: 'fromBox', to: 'toBox'},
        lbs: {from: 'fromLbs', to: 'toLbs'},
        cft: {from: 'fromCft', to: 'toCft'},
    }
}
